// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
// };

const firebaseConfig = {
  apiKey: "AIzaSyCWRI5U0jO_d0DbsdPWBvPWs61nqxJVsA0",
  authDomain: "findai-8e82c.firebaseapp.com",
  projectId: "findai-8e82c",
  storageBucket: "findai-8e82c.firebasestorage.app",
  messagingSenderId: "255732448765",
  appId: "1:255732448765:web:a117ead94b738a74f9ad94"
};

export default firebaseConfig;